function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_lock_icon_svg__cls-1{fill:#393c51}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_lock_icon_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_lock_icon_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "bespoken_lock_icon_svg__cls-1",
  d: "M14.84 9.36h-1.65v-4a5.33 5.33 0 00-9.76-3A.83.83 0 003.3 3a.86.86 0 00.36.55.85.85 0 00.65.13.88.88 0 00.55-.37 3.61 3.61 0 016.61 2v4H4.25v-.46a.87.87 0 00-1.73 0v.51H.87a.87.87 0 00-.87.86v8.67a.87.87 0 00.87.87h14a.87.87 0 00.87-.87v-8.67a.87.87 0 00-.9-.86zM14 18H1.73v-6.91H14z"
}), React.createElement("path", {
  className: "bespoken_lock_icon_svg__cls-1",
  d: "M8.69 14.56a.83.83 0 11-.83-.84.84.84 0 01.83.84z"
})));

var SvgBespokenLockIcon = function SvgBespokenLockIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15.71 19.76"
  }, props), _ref, _ref2);
};

export default SvgBespokenLockIcon;